export enum newViolationConfigurationField {
  violationRule = 'violationRule',
  ruleTag = 'ruleTag',
  severity = 'severity',
  connectors = 'connectors',
  resourceTypes = 'resourceTypes',
  resourceStatus = 'resourceStatus',
  resourceSecurityRisk = 'resourceSecurityRisk',
  resourceBusinessCriticality = 'resourceBusinessCriticality',
  resourceGenerativeAiOptions = 'resourceGenerativeAiOptions',
  resourceCreatedBy = 'resourceCreatedBy',
  resourceLastModifiedBy = 'resourceLastModifiedBy',
  resourceCreatedAt = 'resourceCreatedAt',
  resourceFirstSeenAt = 'resourceFirstSeenAt',
  labels = 'labels',
}
